/* Keeps the Microsoft Clarity brand agent bubble in the bottom-right corner on phones.
 *
 * The widget (#ads-agent-host, open shadow root) scans the page for buttons and links near its
 * corner and lifts itself above them with an inline translateY, for good, so product cards, the
 * quantity buttons or a link scrolling past moved it 100-300 px up the screen. The theme cannot
 * change that logic, but the shadow root is open: one rule there ignores the lifted offset.
 * The composer variant (centred, left-1/2) is left alone. If the widget markup changes the rule
 * simply stops matching and the widget behaves as the vendor ships it. */
(function () {
  var RULE =
    '@media screen and (max-width: 749px){' +
    '[data-testid="entrypoint"]:not([class*="left-1/2"]){transform:none !important}}';
  var attempts = 0;

  function attach() {
    var host = document.getElementById('ads-agent-host');
    var root = host && host.shadowRoot;
    if (!root) {
      if (attempts++ < 60) setTimeout(attach, 500);
      return;
    }
    var style = document.createElement('style');
    style.setAttribute('data-theme-pin', 'clarity-agent');
    style.textContent = RULE;
    root.appendChild(style);
  }

  attach();
})();
